import './styles/MenuAlert.css'
import { useState, useEffect } from 'react';
import Action from './Action'
import Modal from 'react-modal';
import Selector from './Selector'
import SelectorAdmin from './SelectorAdmin'
import InputForm from './InputForm';
import LoadAdding from './LoadAdding';
import ModalFlowNew from './monitor-components/devicesMap/ModalFlowNew';
import ModalDiagnosticNew from './monitor-components/devicesMap/ModalDiagnosticNew';
import { permisos_codigo_id } from './generales/GroupsId'
import React from 'react';
import MenuResetModal from './modals-monitoreo/ResetModal'
import ModalCreateException from './monitor-components/devicesMap/ModalCreateExceptionNew';
import ModalCreateAck from './monitor-components/devicesMap/ModalCreateAckNew';
import ModalCreateTicket from './monitor-components/devicesMap/ModalCreateTicketNew';
import { capitalizeFirstLetter } from '../utils/utils';
import { lang } from './generales/traduction';
import ModalAddProblem from './monitor-components/ModalAddProblem';
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: 'transparent',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '70%',
    padding: '20px',
    border: 'unset'
  },
};
const customStylesFlujo = {
  content: {
    top: '50%',
    left: '50%',
    background: 'transparent',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '90%',
    padding: '20px',
    border: 'unset'
  },
};
const customStylesAnalisis = {
  content: {
    top: '50%',
    left: '50%',
    background: 'transparent',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '80%',
    padding: '20px',
    border: 'unset'
  },
};
const customStylesReset = {
  content: {
    top: '50%',
    left: '50%',
    background: 'transparent',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: '80%',
    padding: '20px',
    border: 'unset'
  },
};
const pingModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#363636',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '85%',
    padding: '20px'
  },
};
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error capturado:", error, errorInfo);
    // Puedes enviar el error a un servicio de monitoreo de errores aquí
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar un mensaje de error personalizado aquí
      return <h1>Oops! Algo salió mal.</h1>;
    }

    return this.props.children;
  }
}
const MenuAlert = ({ isOpen, onClose, props }) => {
  // console.log(props)
  // console.log(props.dataAgencies)
  const [pingModalOpen, setPingModalOpen] = useState(false);
  const [statusPing, setStatusPing] = useState(false);
  const [exeptionOpen, setExeptionOpen] = useState(false);
  const [ackOpen, setAckOpen] = useState(false);
  const [ticketOpen, setTicketOpen] = useState(false);
  const [flujoOpen, setFlujoOpen] = useState(false);
  const [AnalisisOpen, setAnalisisOpen] = useState(false);
  const [addingException, setAddingException] = useState(false);
  const [addingTicket, setAddingTicket] = useState(false);
  const [validaBtn, setValidaBtn] = useState(true);
  const [validaBtnTicket, setValidaBtnTicket] = useState(true);
  const [textAreaValue, setTextAreaValue] = useState('');
  const [closeEvent, setCloseEvent] = useState(false);
  const [traker, setTracker] = useState('');
  const [clock, setClock] = useState('');
  const [ResponseDetail, setResponseDetail] = useState('')
  const [poolRows, setPoolRows] = useState([])
  const [poolObjectRows, setPoolObjectRows] = useState([])
  // console.log(props.data)
  const [dataTicket, setDataticket] = useState({ event_id: props.data.eventid, tracker_id: '', clock: '' })
  const [agenciaId, setAgenciaId] = useState(props.dataAgencies.data.length != 0 ? props.dataAgencies.data.data[0].exception_agency_id : 1);
  const [excepcion, setExcepcion] = useState('');
  const [cerrandoEvento, setCerrandoEvento] = useState(false);
  const [msgError, setMsgError] = useState({ status: false, text: '' })
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTimeString());
  const [modalAddCorIsOpen, setAddCorIsOpen] = React.useState(false);

  // console.log(props.dataAgencies.data.data)
  function openModalAddCor() {
    setAddCorIsOpen(true);
  }

  function closeModalAddCor() {
    setAddCorIsOpen(false);
  }
  function openPingModal() {
    setPingModalOpen(true);
  }

  function closePingModal() {
    setPingModalOpen(false);
  }
  function getCurrentDateTimeString() {
    const now = new Date();
    // Formato de fecha y hora para datetime-local: 'YYYY-MM-DDTHH:MM'
    return now.toISOString().slice(0, 16);
  }
  // //console.log(props.dataAgencies.data.data[0].exception_agency_id)
  const handleTextAreaChange = (event) => {
    if (event.target.value.length === 0) {
      setValidaBtn(true)
    } else {
      setValidaBtn(false)
    }

    setTextAreaValue(event.target.value);
  };

  // console.log(props.data.hostid,agenciaId,excepcion,currentDateTime)





  useEffect(() => {
    const timer = setTimeout(() => {
      closeExeption()

    }, 3000);

    // Limpiar el temporizador cuando el componente se desmonte o se actualice
    return () => clearTimeout(timer);
  }, [addingException]);
  function openExeption() {
    setExeptionOpen(true);
    ////console.log(props)
  }

  function afterOpenExeption() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }
  const cerrarExeption = async (e) => {
    setCerrandoEvento(true)

    var exceptData = {

      "closed_at": currentDateTime
    }
    //console.log(exceptData)
    //console.log(props.server.url+'/api/v1/zabbix/exceptions/close'+props.data.exception_id)

    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/exceptions/close/' + props.data.exception_id, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(exceptData),
      });
      //console.log(response)
      if (response.ok) {
        props.setSearchTerm("")
        const data = await response.json();

        setAddingException(false)
        setCerrandoEvento(false)
        props.search_problems()
      } else {
        const data = await response.json();
        //console.log(data.detail)
        setCloseEvent(false)
        setResponseDetail(data.detail)
        throw new Error('Error en la solicitud');
      }

    } catch (error) {
      setAddingException(false)
      //console.log(error)

    }
  }
  function closeExeption() {
    setExeptionOpen(false);
    // setAddingException(false)
  }
  function closeAck() {
    setAckOpen(false);
    setResponseDetail('')
  }
  function openAck() {
    setAckOpen(true);
    ////console.log(props)
  }

  function closeTicket() {
    setMsgError({ status: false, text: '' })
    setValidaBtnTicket(true)
    setTicketOpen(false);
    setResponseDetail('')
  }
  function openTicket() {
    setTicketOpen(true);
    ////console.log(props)
  }

  useEffect(() => {
    // buscar_info()
  }, [])
  const openFlujo = () => {
    setFlujoOpen(true)
  }
  function closeFlujo() {
    setFlujoOpen(false)
  }
  const openAnalisis = () => {
    setAnalisisOpen(true)
  }
  function closeAnalisis() {
    setAnalisisOpen(false)
  }
  const handleChangeDate = (e) => {
    // ////console.log(e.target)
    const { name, value } = e.target
    // ////console.log(value)
    setClock(value)

  }
  useEffect(() => {
    if (!isEmpty(textAreaValue)) {
      setValidaBtnTicket(false)
    } else {
      setValidaBtnTicket(true)
    }
  }, [textAreaValue])
  function isEmpty(value) {
    return value === null || value === undefined || value === '';
  }


  const [statusTypeTicket, setStatusTypeTicket] = useState(1)
  const [valTypeTicket, setValTypeTicket] = useState('internal_note')
  const changeTypeTicket = (type) => {
    setStatusTypeTicket(type)
    if (type == 1) {
      setValTypeTicket('internal_note')

    } else {
      setValTypeTicket('progress_solution')
    }
  }


  return (
    <>
      {isOpen && (
        <>
          <div className="mh-expand-info">
            <div className="mh-expand-grid">
              <div className="mh-expand-details">
                <div className="mh-detail-group">
                  <div className="mh-det-label">{capitalizeFirstLetter(lang[props.languaje]['dispositivo'])}</div>
                  <div className="mh-det-val" style={{ fontWeight: '600', color: '#0B2A5B' }}>{props.data.Host}</div>
                </div>
                <div className="mh-detail-group">
                  <div className="mh-det-label">IP</div>
                  <div className="mh-det-val"><span className="mh-ip-badge">{props.data.ip}</span></div>
                </div>
                <div className="mh-detail-group" style={{ gridColumn: '1 / -1' }}>
                  <div className="mh-det-label">{capitalizeFirstLetter(lang[props.languaje]['problema'])}</div>
                  <div className="mh-det-val" style={{ fontWeight: '500' }}>{props.data.Problem}</div>
                </div>
                <div className="mh-detail-group">
                  <div className="mh-det-label">{capitalizeFirstLetter(lang[props.languaje]['LastAck'])}</div>
                  <div className="mh-det-val">{props.data.Ack_message || '-'}</div>
                </div>
                <div className="mh-detail-group">
                  <div className="mh-det-label">{capitalizeFirstLetter(lang[props.languaje]['exception'])}</div>
                  <div className="mh-det-val mh-text-warn">{props.data.exception_message || '-'}</div>
                </div>
              </div>

              <div className="mh-expand-actions">
                <div className="mh-actions-hdr">
                  {capitalizeFirstLetter(lang[props.languaje]['acciones'])}
                </div>
                <div className="mh-actions-list">
                  {(props.data.alert_type == 'correlation') ? '' : <Action origen='Azul' disabled={false} titulo={capitalizeFirstLetter(lang[props.languaje]['diagnostico'])} action={openAnalisis} />}
                  {(props.data.alert_type == 'correlation') ? <Action origen='Azul' disabled={false} titulo={capitalizeFirstLetter(lang[props.languaje]['editar'])} action={openModalAddCor} /> : ''}

                  {
                    (props.data.alert_type == 'correlation') ? '' :
                      (props.data.exception_id == null) ? (
                        <Action origen='Azul' disabled={false} titulo={capitalizeFirstLetter(lang[props.languaje]['excepcion'])} action={openExeption} />
                      ) : (cerrandoEvento) ? (
                        <div style={{ fontSize: '12px', color: '#64748b', textAlign: 'center', width: '100%', padding: '8px' }}>cerrando excepción...</div>
                      ) : (
                        <Action origen='Azul' disabled={false} titulo={capitalizeFirstLetter(lang[props.languaje]['cerrarExcepcion'])} action={cerrarExeption} />
                      )
                  }

                  {(props.userPermissions.some(objeto => objeto.permission_id === permisos_codigo_id['acknownledge'])) ? (
                    <Action origen='Azul' disabled={false} titulo='Ack...' action={openAck} />
                  ) : ''}

                  <Action origen='Azul' disabled={false} titulo={capitalizeFirstLetter(lang[props.languaje]['flujo'])} action={openFlujo} />

                  {
                    (props.userPermissions.some(objeto => objeto.permission_id === permisos_codigo_id['link_ticket']) && props.data.alert_type != 'correlation') ? (
                      <div style={{ position: 'relative', flex: 1 }}>
                        <Action origen='Azul' disabled={false} titulo='Ticket' action={openTicket} />
                        {(!props.data.create_ticket) ? <div className="tooltiptextAction" >{'Datos incompletos para creacion de tickets'}</div> : ''}
                      </div>
                    ) : ''
                  }

                  {
                    (props.userPermissions.some(objeto => objeto.permission_id === permisos_codigo_id['RESET']) && props.data.object_id) ? (
                      <Action origen='Azul' disabled={false} titulo='RESET' action={openPingModal} />
                    ) : ''
                  }
                </div>
              </div>
            </div>
          </div>
          <Modal
            isOpen={exeptionOpen}
            onAfterOpen={afterOpenExeption}
            onRequestClose={closeExeption}
            style={customStyles}
            contentLabel="Example Modal"
            shouldCloseOnOverlayClick={false}
          >
            <ModalCreateException closeExeption={closeExeption} props={props}></ModalCreateException>
          </Modal>
          <Modal
            isOpen={ackOpen}
            onAfterOpen={afterOpenExeption}
            onRequestClose={closeAck}
            style={customStyles}
            contentLabel="Example Modal"
            shouldCloseOnOverlayClick={false}
          >
            <ModalCreateAck setImportModalOpen={props.setImportModalOpen} setSuveryId={props.setSuveryId} closeAck={closeAck} props={props}></ModalCreateAck>
          </Modal>
          <Modal
            isOpen={ticketOpen}
            onAfterOpen={afterOpenExeption}
            onRequestClose={closeTicket}
            style={customStyles}
            contentLabel="Example Modal"
            shouldCloseOnOverlayClick={false}
          >
            <ModalCreateTicket setImportModalOpen={props.setImportModalOpen} setSuveryId={props.setSuveryId} closeTicket={closeTicket} props={props}></ModalCreateTicket>
          </Modal>
          <Modal
            isOpen={flujoOpen}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closeFlujo}
            style={customStylesFlujo}
            contentLabel="Example Modal"
          // shouldCloseOnOverlayClick={true}
          >
            <ErrorBoundary>
            <ModalFlowNew eventId={props.data.eventid} props={props} onClose={closeFlujo}></ModalFlowNew>
            </ErrorBoundary>

          </Modal>
          <Modal
            isOpen={AnalisisOpen}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closeAnalisis}
            style={customStylesAnalisis}
            contentLabel="Example Modal"
          // shouldCloseOnOverlayClick={true}
          >
            <ModalDiagnosticNew eventId={props.data.eventid} props={props} onClose={closeAnalisis}></ModalDiagnosticNew>
          </Modal>

          <Modal
            isOpen={pingModalOpen}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closePingModal}
            style={customStylesReset}
            contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <MenuResetModal eventId={props.data.eventid} handleShowPopup={props.handleShowPopup} props={props} isOpen={pingModalOpen} data={props.data} statusPing={statusPing} closeActionModal={closePingModal} />
            {/* <AnalisisModal eventId={props.data.eventid} props={props}></AnalisisModal> */}
            {/* <ResetModal mode={''} handleShowPopup={props.handleShowPopup} server={props.server}isOpen={pingModalOpen} data={props.data} statusPing={statusPing} closeActionModal={closePingModal}></ResetModal> */}
            {/* <PingModal actionSelected={actionSelected} server={server}isOpen={pingModalOpen} data={data} statusPing={statusPing} closePingModal={closePingModal}></PingModal> */}
          </Modal>
          <Modal
            isOpen={modalAddCorIsOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModalAddCor}
            style={addHostModalStyles}
            contentLabel="Example Modal"
          >
            <ModalAddProblem event={props.data} editActive={true} search_problems={props.search_problems} poolObjectRows={poolObjectRows} setPoolObjectRows={setPoolObjectRows} poolRows={poolRows} server={props.server} handleShowPopup={props.handleShowPopup} setPoolRows={setPoolRows} languaje={props.languaje} mode={props.mode} closeAddHostModal={closeModalAddCor} />
          </Modal>
        </>
      )}
    </>
  );
};

export default MenuAlert